module.exports = __webpack_public_path__ + "img/logo_1.d8a814d0.png";